import React, { useState } from 'react';
import {
	Card,
	CardRow,
	StyledH2,
	SummaryValue,
	StyledLink,
	ModalContent,
	CloseModalSpan,
	SummarySpan,
} from './style';

import { ObjectivesContantsNames } from '../../../containers/campanhas/Briefing';
import Modal from '../Modal';
import Idea from '../../../img/idea.png';


const AdhesionModal = ({ modalOpen, setModalOpen }) => (
	<Modal
		isOpen={modalOpen}
		openAction={() => setModalOpen(!modalOpen)}
		borderRadius="8px"
		contentWidth="80%"
	>
		<CloseModalSpan onClick={() => setModalOpen(false)}>X</CloseModalSpan>
		<ModalContent>
			<div className="row justify-content-center">
				<img src={Idea} alt="" />
			</div>
			<h1>Termo de adesão</h1>
			<p>
				Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur eros dolor,
				tincidunt at egestas ac, porttitor sed mauris. Mauris nec enim viverra, dictum elit non,
				blandit magna. Curabitur placerat molestie orci, a aliquet enim laoreet ut.
				Nam varius lobortis elit, eu cursus justo interdum eget. Donec consectetur lectus quam.
				In dignissim erat ut orci convallis, eget consectetur nibh efficitur.
				Nunc eget justo nisi.
				In leo ligula, efficitur in ipsum auctor, maximus pulvinar turpis.
				Nunc tristique tellus sit amet turpis molestie, efficitur viverra velit tristique.
				Aliquam malesuada dui non quam tempus malesuada.
				Fusce in nibh malesuada metus aliquam suscipit.
				Fusce sit amet faucibus mi.
				Aenean aliquam placerat ante, eu placerat augue malesuada sed.
				Sed lorem enim, ornare a ipsum vitae, sollicitudin ullamcorper lorem.
				Donec dignissim nisl est, sit amet ultrices diam sodales vitae.
			</p>
			<p>
				Nullam enim nisl, vehicula sit amet tincidunt nec, pellentesque sed nulla.
				Phasellus mi enim, placerat eu ullamcorper in, consequat vitae arcu.
				Cras pharetra pretium metus non blandit.
				Suspendisse venenatis in nibh vitae dictum.
				Curabitur a eros orci.
				Praesent sed facilisis tellus.
				Proin et mollis lorem.
			</p>
			<p>
				Nullam arcu nunc, condimentum at rutrum luctus, tincidunt a eros.
				Pellentesque egestas pretium dui, sit amet posuere ligula luctus ac.
				Quisque ultrices ipsum et mollis tristique.
				Donec bibendum egestas elit.
				Cras feugiat turpis quis lacus pellentesque, a blandit arcu dignissim.
				Sed faucibus molestie eros, ut pharetra nisi dictum vehicula.
				Quisque at consequat diam. Donec in fermentum lorem.
			</p>
		</ModalContent>
	</Modal>
);

const CampaignSummary = ({
	selectedChannel,
	campaignObjective,
	logoName,
	locations,
	campaignInvestment,
	fileName,
	prospectionClients,
	aprovedClients,
	recentLeadClients,
	newClients,
	campaignType,
}) => {
	const [modalOpen, setModalOpen] = useState(false);

	const renderRecurringCampaign = () => (
		<>
			<CardRow>
				<SummaryValue>Canal:</SummaryValue>
				<SummaryValue bold>{ selectedChannel }</SummaryValue>
			</CardRow>
			<CardRow>
				<SummaryValue>Objetivo:</SummaryValue>
				<SummaryValue bold>
					{
						ObjectivesContantsNames[campaignObjective]
							? ObjectivesContantsNames[campaignObjective]
							: campaignObjective
					}
				</SummaryValue>
			</CardRow>
			<CardRow>
				<SummaryValue>Logo:</SummaryValue>
				<SummaryValue bold>{ logoName }</SummaryValue>
			</CardRow>
			<CardRow>
				<SummaryValue>Locais:</SummaryValue>
				<SummaryValue bold>{ locations }</SummaryValue>
			</CardRow>
		</>
	);

	const renderOneOffCampaign = () => (
		<>
			<CardRow>
				<SummaryValue>Lista:</SummaryValue>
				<SummaryValue bold>{ fileName }</SummaryValue>
			</CardRow>
			<CardRow>
				<SummaryValue bold>Clientes para prospecção:</SummaryValue>
				<SummaryValue bold className="red">{ prospectionClients }</SummaryValue>
			</CardRow>
			<CardRow>
				<SummaryValue>Clientes com crédito aprovado para Financiamento Santander:</SummaryValue>
				<SummaryValue bold>{ aprovedClients }</SummaryValue>
			</CardRow>
			<CardRow>
				<SummaryValue>Clientes que efetuaram buscas recentes na Webmotors:</SummaryValue>
				<SummaryValue bold>{ recentLeadClients }</SummaryValue>
			</CardRow>
			<CardRow>
				<SummaryValue>Novos clientes:</SummaryValue>
				<SummaryValue bold>{ newClients }</SummaryValue>
			</CardRow>
		</>
	);

	const SummariesRenders = {
		pontual: renderOneOffCampaign,
		recorrente: renderRecurringCampaign,
	};

	return (
		<>
			<AdhesionModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
			<div className="row">
				<div className="col-12 col-md-7">
					<Card>
						<StyledH2>Resumo do Briefing:</StyledH2>
						{SummariesRenders[campaignType]()}
					</Card>
				</div>
				<div className="col-12 col-md-5">
					<Card className="mb-4">
						<StyledH2>Valor da contratação:</StyledH2>
						<CardRow>
							<SummaryValue>Modalidade:</SummaryValue>
							<SummaryValue bold className="red">Mensal, recorrente</SummaryValue>
						</CardRow>
						<CardRow>
							<SummaryValue>Valor:</SummaryValue>
							<SummaryValue bold className="red">{campaignInvestment}/mês</SummaryValue>
						</CardRow>
					</Card>
					<SummarySpan>
						{'Você leu e concordou com o '}
						<StyledLink onClick={() => setModalOpen(true)}>Termo de adesão</StyledLink>
					</SummarySpan>
				</div>
			</div>
		</>
	);
};

export default CampaignSummary;
